export const MEDIA_QUERY_FIELD_ALWAYS_VISIBLE = 'xl';
